import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const MAIN_TABS = [
  { path: "/", label: "인기" },
  { path: "/deals", label: "할인" },
  { path: "/free", label: "무료" },
  { path: "/search", label: "검색" },
];

const MORE_ITEMS = [
  { path: "/store", label: "스토어" },
  { path: "/price-compare", label: "가격비교" },
  { path: "/tags", label: "태그" },
  { path: "/releases", label: "릴리즈" },
  { path: "/calendar", label: "캘린더" },
  { path: "/compare", label: "비교" },
  { path: "/wishlist", label: "관심목록" },
];

export default function TossBottomNav() {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);

  const isMoreActive = MORE_ITEMS.some((item) => location.pathname.startsWith(item.path));

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <>
      {showMore && (
        <>
          <div className="fixed inset-0 bg-black/40 z-[55]" onClick={() => setShowMore(false)} />
          <div className="fixed bottom-[76px] left-3 right-3 z-[60]">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="grid grid-cols-4 gap-px bg-gray-100">
                {MORE_ITEMS.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setShowMore(false)}
                    className={`flex items-center justify-center py-3.5 bg-white text-sm font-medium transition-colors active:bg-gray-50 ${
                      isActive(item.path) ? "text-blue-600" : "text-gray-600"
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </>
      )}

      <nav className="fixed bottom-3 left-3 right-3 z-50 bg-white/95 backdrop-blur-md rounded-2xl shadow-lg border border-gray-200/60">
        <div className="flex items-stretch">
          {MAIN_TABS.map((tab) => {
            const active = isActive(tab.path);
            return (
              <Link
                key={tab.path}
                to={tab.path}
                onClick={() => setShowMore(false)}
                className={`flex-1 flex items-center justify-center py-3 text-[13px] font-semibold transition-colors ${
                  active ? "text-blue-600" : "text-gray-400"
                }`}
              >
                {tab.label}
              </Link>
            );
          })}
          <button
            onClick={() => setShowMore(!showMore)}
            className={`flex-1 flex items-center justify-center py-3 text-[13px] font-semibold transition-colors ${
              isMoreActive || showMore ? "text-blue-600" : "text-gray-400"
            }`}
          >
            더보기
          </button>
        </div>
      </nav>
    </>
  );
}
